var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 46,
    rx: 10,
    fill: "#6D5FF2",
    fillOpacity: 0.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 26H34V14H30M26 14H17C16.17 14 15.46 14.5 15.16 15.22L12.14 22.27C12.05 22.5 12 22.74 12 23V25C12 25.5304 12.2107 26.0391 12.5858 26.4142C12.9609 26.7893 13.4696 27 14 27H20.31L19.36 31.57C19.34 31.67 19.33 31.77 19.33 31.88C19.33 32.3 19.5 32.67 19.77 32.94L20.83 34L27.41 27.41C27.78 27.05 28 26.55 28 26V16C28 15.4696 27.7893 14.9609 27.4142 14.5858C27.0391 14.2107 26.5304 14 26 14Z",
    fill: "#6D5FF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/Dislike.0339c76e680e72604c21849255715856.svg";
export { ForwardRef as ReactComponent };